<template>
  <section class="mainSection">
    <h1>Portfolio</h1>
    <template v-for="item of items">
      <router-link :key="item.id_num" :to=" item.url_title ">
        <p>{{ item.title }}</p>
      </router-link>
    </template>
  </section>
</template>

<script>
export default {
  name: "Showcase",
  data() {
    return {
      items: []
    };
  },
  created: function() {
    this.items = this.$store.getters.allItems;
  }
};
</script>

<style scoped lang="scss">
section.mainSection {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 1rem;
  margin: 1rem 0;

  p {
    font-size: calc(16px + 2vw);
    transition: color 1s ease;
    &:hover {
      color: $lightPrimary;
    }
  }
}
a:visited {
  color: $lightQuatery;
}
</style>
